/* eslint-disable @typescript-eslint/no-unused-expressions */
/** 数美组织id */
export const SM_ORIGANIZATION_ID = 'cFQNeGqiYuwSu1gVbnXM'
/** 数美publickey */
export const SM_PUBLIC_KEY =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDFradp+bFLRciQjYSdMc2knrWUoCqbtwhRl5uAqqBcjhEwCKjcyuevLEZr094KOmiEiIkQsbflf8gyMXBd6dRV9UNQXhKgulgfyfczm9c7BGashZBiq3e+BZGWjNUg+wbsmA5OE5mIro0+ZWGB0A1zGfqv5aUGVDXgetK+tBv15QIDAQAB'

/** 数美publickey h5 */
export const SM_PUBLIC_KEY_H5 =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCQms0xsETlx9fZ7fu7aJBVfQ0VoPDLNc05qRev34slz2iAbtwUu7JvDXCgF2UlqQKLiTjhYRuQnmUpjWkxLX1rJY0Bf14zYYnMB+IkG82l/ysG8D8IIqmhP5ir3RfXyqZJYg4A6fKfajPhottvqyXGWIz8IQUasTCSB2V0pJYNCQIDAQAB'

/** 数美私有化 地址 */
export const SM_SERVER_URL = 'risk.cdfsunrise.com'
/** 数美私有化 test 地址 */
export const SM_SERVER_URL_TEST = 'risk-test.cdfsunrise.com'

export const SMSdkH5Init = () => {
  window._smReadyFuncs = []
  window.SMSdk = {
    onBoxDataReady: function (boxData) {
      // 非必填
      console.log('此时拿到的数据为boxData或者boxId', boxData)
    },
    ready: function (fn) {
      fn && window._smReadyFuncs.push(fn)
    },
  }

  // 1. 通用配置项
  window._smConf = {
    organization: SM_ORIGANIZATION_ID, // 必填，组织标识，邮件中organization项
    appId: 'default', // 必填，应用标识，默认传值default，其他应用标识提前联系数美协助定义
    publicKey: SM_PUBLIC_KEY_H5, // 必填，私钥标识，邮件中publicKey项
    staticHost: 'lefox-app-cdn-dev.cdfsunrise.com', // 必填, 设置JS-SDK文件域名，建议填写static.portal101.cn
    protocol: 'https', // 如果使用https，则设置，如不使用，则不设置这个字段
    apiHost: process.env.DEPLOY_ENV === 'prod' ? SM_SERVER_URL : SM_SERVER_URL_TEST,
  }

  const url = (function () {
    const isHttps = 'https:' === document.location.protocol
    const protocol = isHttps ? 'https://' : 'http://'
    const fpJsPath = '/public/js/fp.min.js'
    return protocol + window._smConf.staticHost + fpJsPath
  })()
  const sm = document.createElement('script')
  const s = document.getElementsByTagName('script')[0]
  sm.src = url
  s.parentNode.insertBefore(sm, s)
}

/** 获取h5 风控 deviceid */
export const getH5SmDeviceId = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    // resolve('')
    // return
    let smDeviceId = ''
    let smDeviceIdReady = false
    window.SMSdk.ready(function () {
      if (window.SMSdk?.getDeviceId) {
        smDeviceId = window.SMSdk?.getDeviceId()
      }
      if (!smDeviceIdReady) {
        smDeviceIdReady = true
        // 执行业务逻辑
        resolve(smDeviceId)
      } else {
        reject()
      }
    })
  })
}

/** 展示h5风控滑块 */
export const showSmCaptcha = (cb) => {
  // @ts-ignore
  initSMCaptcha(
    {
      organization: SM_ORIGANIZATION_ID, // 数美后台可以查看公司标识

      // 连接新加坡机房特殊配置项，仅供验证码数据上报新加坡机房客户使用
      // domains: ["captcha-xjp.fengkongcloud.cn"],

      // 连接美国机房特殊配置项，仅供验证码数据上报美国机房客户使用
      // domains: ["captcha-fjny.fengkongcloud.cn"],
      product: 'popup', // 展现形式，具体选项见下表
      mode: 'slide', // 验证码模式，具体选项见下表
      width: '70%',
      appendTo: 'captchaId', // 验证码dom元素的id，
    },
    function (SMCaptcha) {
      // 验证码实例，可以调用实例上的方法
      console.log(SMCaptcha, 'SMCaptcha')

      const captchaUuid = SMCaptcha.captchaUuid
      SMCaptcha.onReady(() => {
        SMCaptcha.verify()
      })
      // 验证码校验情况回调
      SMCaptcha.onSuccess(function (data) {
        // data格式：{rid: '2017080810405655b3377d25de478233', pass: false}
        console.log(captchaUuid, data)
        if (data.pass) {
          cb?.(data)
          // 验证通过后
        }
      })
    }
  )
}
